export default __webpack_public_path__ + "static/media/promo-muggle-murders-rise_00.8acdc4f2.jpg";